<div #grid class="grid page">

    <div class="grid-cell top-left">

        <p #logo class="logo">

            <i aria-hidden="true" class="fa-regular fa-brain icon"></i>
            <span class="gradient-text text"><em>Actionable</em> Insights</span>
        </p>

        <div *ngIf="showSideOptions()"
             [pTooltip]="sideCollapsable() ? 'Collapse' : 'Expand'"
             [tooltipDisabled]="animating"
             [tooltipPosition]="'right'"
             [hideDelay]="300"
             [showDelay]="1000"
             (click)="toggleSideExpanded()"
             class="side-navigation-toggle">

            <div>
                <i [ngClass]="{'rotated': !sideCollapsable()}"
                   aria-hidden="true"
                   class="fa-solid fa-chevron-left"></i>
            </div>
        </div>
    </div>

    <header class="grid-cell top-right"></header>

    <nav class="grid-cell bottom-left side-navigation">

        <ng-container *ngFor="let group of navigation">

            <div [ngClass]="group.className" class="nav-group">

                <h4 *ngIf="group.title"
                    #navGroupTitle
                    class="nav-group-title">
                    {{ group.title }}
                </h4>

                <ul>
                    <li *ngFor="let item of group.items"
                        [ngClass]="{ selected: selectedPage === item.page }">

                        <a [routerLink]="[item.route]"
                           [pTooltip]="item.label"
                           [tooltipDisabled]="animating"
                           [tooltipPosition]="'right'"
                           [hideDelay]="300"
                           [showDelay]="1000">

                            <i aria-hidden="true" [class]="item.icon"></i>
                            <span #navLabel class="nav-label">{{ item.label }}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </ng-container>
    </nav>

    <main class="grid-cell bottom-right">

        <div class="content">
            <router-outlet></router-outlet>
        </div>
    </main>
</div>
